import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showSuccessSnackbar } from 'modules/snackbar';
import {
  calculatePriceSet,
  salesCalculateReportMemoSet,
  salesCalculateReportMemoModify,
  calculateExlPriceSet,
} from 'lib/api/sales';
import Modal from 'components/organisms/NewModal';
import NewInput from 'components/atoms/NewInput';

const CalculateModal = (props) => {
  const {
    modal,
    handleReFetch = (f) => f,
    getModalParam = (f) => f,
    handleModalClose = (f) => f,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const initParams = {
    ...modal.params,
  };
  const initError = {
    memo: {
      state: false,
      helperText: '',
    },
    price: {
      state: false,
      helperText: '',
    },
    dlOrderAmtUs: {
      state: false,
      helperText: '',
    },
    rsnAmt: {
      state: false,
      helperText: '',
    },
  };
  const [params, setParams] = useState(initParams); // 모달 자체에서 쓰는 params
  const [error, setError] = useState(initError);

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  const callAxios = (params, url) => {
    handleReFetch(true);
    url(params)
      .then((response) => {
        const data = response.data;
        handleClickSnackbar({
          message: data.message,
          option: {
            type: 'success',
          },
        });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        handleReFetch(false);
      });
  };

  /**
   * 모달에 submit 버튼을 눌렀을 때 실행되는 함수
   */
  const handleSubmit = () => {
    let newParams = { ...params };

    //모비온(실지급액수정)
    if (modal.params.adutSvcTpCode === '01' && modal.type === 'priceEdit') {
      if (typeof params.price === 'undefined' || params.price === '') {
        setError({
          ...initError,
          price: {
            state: true,
            helperText: '필수 입력값 입니다.',
          },
        });
        return false;
      }
      newParams = {
        ...newParams,
        adutSvcTpCode: modal.params['adutSvcTpCode'],
        statsMth: modal.params['statsMth'],
        price: params['price'],
      };
      callAxios(newParams, calculatePriceSet);
    }
    //모비온(메모등록)
    if (modal.type === 'historyAdd') {
      if (typeof params.memo === 'undefined' || params.memo === '') {
        setError({
          ...initError,
          memo: {
            state: true,
            helperText: '필수 입력값 입니다.',
          },
        });
        return false;
      }
      newParams = {
        ...params,
        adutSvcTpCode: modal.params['adutSvcTpCode'],
        statsMth: modal.params['statsMth'],
      };
      callAxios(newParams, salesCalculateReportMemoSet);

      //모비온(메모수정)
    } else if (modal.type === 'historyEdit') {
      newParams = {
        ...params,
        memo: params['memo'],
        no: modal.params['no'],
      };
      callAxios(newParams, salesCalculateReportMemoModify);

      //연동사리포트 (금액수정)
    } else if (modal.type === 'endPriceEdit') {
      if (
        typeof params.dlOrderAmtUs === 'undefined' ||
        params.dlOrderAmtUs === ''
      ) {
        setError({
          ...initError,
          dlOrderAmtUs: {
            state: true,
            helperText: '필수 입력값 입니다.',
          },
        });
        return false;
      }
      if (typeof params.rsnAmt === 'undefined' || params.rsnAmt === '') {
        setError({
          ...initError,
          rsnAmt: {
            state: true,
            helperText: '필수 입력값 입니다.',
          },
        });
        return false;
      }
      newParams = {
        ...params,
        dtlItlId: modal.params['dtlItlId'],
        statsMth: modal.params['statsMth'],
        adutSvcDtlTpCode: modal.params['adutSvcDtlTpCode'],
        dlOrderAmtUs: params['dlOrderAmtUs'],
        rsnAmt: params['rsnAmt'],
      };
      callAxios(newParams, calculateExlPriceSet);
    }
    getModalParam({
      ...modal,
      open: false,
    });
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <Modal
        open={modal.open}
        headerTitle={modal.modalTitle}
        handleClose={handleModalClose}
        confirmBtnTitle={modal.confirmBtnTitle}
        confirmOnClick={handleSubmit}
        useForm={true}
      >
        {modal.params.adutSvcTpCode === '01' && modal.type === 'priceEdit' && (
          <tr>
            <th>{t('실 지급액')}</th>
            <td>
              <NewInput
                type="tableInput"
                name="price"
                callBack={getParam}
                label={'Price'}
                params={params}
                value={modal.params['price']}
                error={error.price.state}
                helperText={error.price.helperText}
              />
            </td>
          </tr>
        )}
        {modal.type === 'endPriceEdit' && (
          <>
            <tr>
              <th>{t('마감금액')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="dlOrderAmtUs"
                  callBack={getParam}
                  label={'마감금액'}
                  params={params}
                  value={modal.params['dlOrderAmtUs']}
                  error={error.dlOrderAmtUs.state}
                  helperText={error.dlOrderAmtUs.helperText}
                />
              </td>
            </tr>
            <tr>
              <th>{t('비고액')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  name="rsnAmt"
                  callBack={getParam}
                  label={'비고액'}
                  params={params}
                  value={modal.params['rsnAmt']}
                  error={error.rsnAmt.state}
                  helperText={error.rsnAmt.helperText}
                />
              </td>
            </tr>
          </>
        )}
        {(modal.type === 'historyAdd' || modal.type === 'historyEdit') && (
          <tr>
            <th>{t('히스토리 내용')}</th>
            <td>
              <NewInput
                type="tableInput"
                name="memo"
                label={'History'}
                callBack={getParam}
                params={params}
                value={modal.params['memo']}
                error={error.memo.state}
                helperText={error.memo.helperText}
              />
            </td>
          </tr>
        )}
      </Modal>
    </>
  );
};
export default CalculateModal;
